import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MSRemoteLoggerCategory } from '../adapters/remote-logger/utils/remote-logger.utils';
import { CONSTANTS } from '../services/config.service';
import { LoggerService } from '../services/logger.service';
import { NavigationService } from '../services/navigation/navigation.service';
import { RegistrationService } from '../services/registration/registration.service';
import { SignupSurveyService } from '../services/signup-survey.service';
import { TripSurveyService } from '../services/trip-survey.service';
import { UrlService } from '../services/url.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyGuard implements CanActivate {
  navigationTrigger = '';

  constructor(
    private nav: NavigationService,
    private logger: LoggerService,
    private registration: RegistrationService,
    private signupSurvey: SignupSurveyService,
    private tripSurvey: TripSurveyService,
    private url: UrlService
  ) {
    this.url.navigationTrigger$.subscribe((navigationTrigger: string) => {
      this.navigationTrigger = navigationTrigger;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = next.url[0].path;
    const surveyType = next.url[1].path;

    if (this.navigationTrigger === 'popstate') {
      return false;
    }

    this.logger.log(
      'Survey guard - app initialized:',
      MSRemoteLoggerCategory.SURVEY_GUARD_SERVICE,
      CONSTANTS.registrationInitialized,
      'registration initialized:',
      CONSTANTS.appInitialized
    );

    const nav = (target) => {
      this.logger.log('User navigating to:', MSRemoteLoggerCategory.SURVEY_GUARD_SERVICE, url, 'App says go to:', target);

      if (target[0] === '/' + url) {
        return true;
      } else {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.nav.nav(target);
        return false;
      }
    };

    // need to prevent backing into signup survey after it's complete
    if (surveyType === CONSTANTS.surveyTypes.SIGNUP && CONSTANTS.appInitialized) {
      return this.registration.getNextPage().then((target) => nav(target));
    }

    // survey dbs are assigned if device and null if web. db is only undefined if service not initialized
    if (surveyType === CONSTANTS.surveyTypes.SIGNUP && this.signupSurvey.db !== undefined) {
      return true;
    }
    if (surveyType !== CONSTANTS.surveyTypes.SIGNUP && this.tripSurvey.db !== undefined) {
      return true;
    }

    return this.registration.initialize().then((target) => nav(target));
  }
}
